import { INCIDENT_STATUSES } from '../types/incident.types'
import type { Incident, IncidentStatus } from '../types/incident.types'
import { KanbanColumn } from './KanbanColumn'

interface KanbanViewProps {
  incidents: Incident[]
  onSelect?: (id: number) => void
}

export function KanbanView({ incidents, onSelect }: KanbanViewProps): JSX.Element {
  const grouped = groupByStatus(incidents)

  return (
    <div className="flex gap-4 overflow-x-auto pb-2">
      {INCIDENT_STATUSES.map((status) => (
        <KanbanColumn
          key={status}
          status={status}
          incidents={grouped[status]}
          onSelect={onSelect}
        />
      ))}
    </div>
  )
}

function groupByStatus(incidents: Incident[]): Record<IncidentStatus, Incident[]> {
  const initial: Record<IncidentStatus, Incident[]> = {
    DRAFT: [],
    NEW: [],
    ACKNOWLEDGE: [],
    IN_PROGRESS: [],
    BLOCKED: [],
    DONE: [],
    CLOSED: [],
  }
  return incidents.reduce((acc, incident) => {
    acc[incident.status].push(incident)
    return acc
  }, initial)
}
